export const THEME_TABS = {
    LIST_OF_THEME: { id: 10, name: 'list-of-themes' },
    CREATE_OR_EDIT: { id: 20, name: 'create-or-edit' },
    PUBLISH: { id: 30, name: 'publish' },
};
